export default __webpack_public_path__ + "static/secondStep-439fa1764c52be1ad8836e8f9f24a8c4.png";